import script from "./FullDeckGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./FullDeckGrid.vue?vue&type=script&setup=true&lang=js"

import "./FullDeckGrid.vue?vue&type=style&index=0&id=4cfbb9d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cfbb9d0"]])

export default __exports__